import React from 'react'
import {Presenter} from './Presenter'

export const ImportUpdate = () => {
  return <Presenter />
}
